/* eslint-disable react/no-array-index-key */
import React, { FC, useState } from 'react';
import cn from 'classnames';
import BalanceModal from 'components/BalanceModal';
import { useLocation } from 'react-router';
import { someGroups } from 'utils/statics/everyGroups';
import { useUserInfo } from 'domains/user/model/selectors';
import css from './styles.module.scss';
import Tooltip from '../UI/Tooltip';
import { ReactComponent as UpdateSvg } from './icons/update.svg';
import { ReactComponent as WalletSvg } from '../../assets/wallet.svg';
import { useDelayedLoading } from './hooks/useDelayedLoading';

type BalanceProps = {
  classname?: string;
  white?: boolean;
  transparent?: boolean;
  value: null | number;
  currency: null | string;
  name?: string;
  isLoading: boolean;
  fetcher?: () => void;
  isTooltip?: boolean;
  revert?: boolean;
};

const Balance: FC<BalanceProps> = ({
  classname,
  white,
  transparent,
  value,
  fetcher,
  currency,
  isLoading,
  name,
  isTooltip = false,
  revert,
}) => {
  const [modal, setModal] = useState(false);
  const { data: userInfo } = useUserInfo();
  const location = useLocation();

  const isClientsList = location.pathname === '/main/clients';
  const isAccount = someGroups(userInfo, 'account');

  const openModalClickHandler = () => {
    if (isClientsList && isAccount) {
      setModal(true);
    }
  };

  const LOADER_ITEMS_COUNT = 5;
  const delayedLoading = useDelayedLoading(isLoading, 400);
  
  if(value === null && !isLoading) return null;

  return (
    <>
      <div
        className={cn(css.balance, classname, {
          _bg: value !== null,
          _isRedText: Number(value) < 0,
          _isWhite: white,
          _isTransparent: transparent,
          _isRevert: revert,
          _isLoading: delayedLoading,
        })}
      >
        {delayedLoading ? (
          <div className={css.loading}>
            <div className={css.loading_items}>
              {Array.from({ length: LOADER_ITEMS_COUNT }).map((_, index) => (
                <div key={index} className={css.loading_line} />
              ))}
            </div>
            <UpdateSvg className={css.loading_circle} />
          </div>
        ) : (
          <>
            {value !== null ? (
              <>
                {isTooltip ? (
                  <Tooltip
                    className={css.tooltip}
                    classNameHint={css.tooltipHint}
                    bottom
                    white
                    onClick={openModalClickHandler}
                    title={
                      <div className={cn(css.balanceValue, 'balanceValue')}>
                        {isClientsList && isAccount && <WalletSvg />}
                        <div>
                          {String(value).replace(
                            /(\d)(?=(\d\d\d)+([^\d]|$))/g,
                            '$1 ',
                          )}{' '}
                          {currency}
                        </div>
                      </div>
                    }
                  >
                    <p>{name}</p>
                  </Tooltip>
                ) : (
                  <div className={cn(css.balanceValue, 'balanceValue')}>
                    {String(value).replace(
                      /(\d)(?=(\d\d\d)+([^\d]|$))/g,
                      '$1 ',
                    )}{' '}
                    {currency}
                  </div>
                )}
                {fetcher && (
                  <UpdateSvg className={css.balanceUpdate} onClick={fetcher} />
                )}
              </>
            ) : (
              '-'
            )}
          </>
        )}
      </div>
      {modal && <BalanceModal onClose={() => setModal(false)} />}
    </>
  );
};

export default Balance;
